import { GameProps, gamePropsNull } from './game.props'
import { Game } from './game'

export class SettlingGame extends Game {
  public constructor(settlingGameProps: GameProps) {
    super(settlingGameProps)
  }
}

export const settlingGameNull: SettlingGame = new SettlingGame({
  ...gamePropsNull,
  gameStatus: 'Settling',
})
